import React, { useContext, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { ToastContainer } from "react-toastify";
import { StoreContext } from "../context/context";
import Backdrop from "./Backdrop";
const Menubar = dynamic(() => import("./Menubar"), {
  ssr: false,
});
import FavouritesRight from "./FavouritesRight";
import isMobile from "is-mobile";

const WhatsappDesktop = dynamic(() => import("./WhatsappDesktop"), {
  ssr: false,
});
const Footer = dynamic(() => import("../static/Footer"));

const Layout = ({ ssr, children, isAppWebView, deviceType }) => {
  const [isPhone, setIsPhone] = useState(false);

  const { setPage, setCurrentRoutingTypeId, currentRoutingTypeId } =
    useContext(StoreContext) || {};

  useEffect(() => {
    setIsPhone(isMobile());
  }, []);

  useEffect(() => {
    setCurrentRoutingTypeId(ssr.RoutingTypeId);
    setPage(ssr.result);
  }, [ssr]);

  return (
    <>
      {children}
      <Backdrop />
      <ToastContainer />
      <FavouritesRight />
      <Menubar
        ssr={ssr.result}
        RoutingTypeId={ssr.RoutingTypeId}
        isAppWebView={isAppWebView}
        deviceType={deviceType}
      />
      {!isPhone ? <WhatsappDesktop /> : null}
      {ssr.result.footer != "0" && ssr.disableHeader != true && (
        <Footer ssr={ssr} />
      )}
    </>
  );
};

export default Layout;
